import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const CompletedStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    middleContent: {
        ...OnboardingStyle(theme).middleContent,
        justifyContent: 'flex-end',
        marginBottom: theme.spacing(7.5),
    },
    dragon: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 'auto',
        maxWidth: '650px',
        height: 'auto',

        [theme.breakpoints.up(445)]: {
            width: '100%',
        }
    },
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepCompleted/completed.styles.ts